import styled from 'styled-components';

export const SelectionFilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SelectionFilterHeading = styled.h6`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 0px;
`;

export const ClearAll = styled.span`
  color: ${({ theme }) => theme.palette.grey800};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  cursor: pointer;
`;

export const ShowMoreToggle = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  margin-top: 8px;
  color: ${({ theme }) => theme.palette.primaryBrand};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  cursor: pointer;
`;
